import { render, staticRenderFns } from "./RecoverPasswordView.vue?vue&type=template&id=320123e3&scoped=true&lang=pug&"
import script from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordView.vue?vue&type=style&index=0&id=320123e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320123e3",
  null
  
)

export default component.exports